import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ModalSize } from 'src/app/Enums/usersFilterEnums';
import { Material } from 'src/app/shared/classes/Material';
import { Outward } from 'src/app/shared/classes/Outward';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { OutwardService } from 'src/app/shared/services/outward.service';
import { OutwardMaterial } from '../../../shared/classes/Material';
import { Location } from '@angular/common';
import { SupervisorCommentsComponent } from '../supervisor-comments/supervisor-comments.component';
import { OutwardStatus, OutwardStatusName } from 'src/app/Enums/outwardEnum';
import { AuditData } from 'src/app/shared/classes/AuditTrail';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as mammoth from 'mammoth';

@Component({
  selector: 'app-view-outward-supervisor',
  templateUrl: './view-outward-supervisor.component.html',
  styleUrls: ['./view-outward-supervisor.component.less']
})
export class ViewOutwardSupervisorComponent implements OnInit {

  dateInputData: any = {};
  requestId: number;
  requestName: string;
  requestTypeId: number;
  requestTypeName: string;
  requestDateTime:any;
  revisedDateTime: any;
  receivedDateTime: any;
  returnDateTime: any;
  remark: string;
  gatepassNumber: string;
  serialNumber: string;
  materialSentToVendorId: number;
  materialSentToVendorName: string;
  materialCarriedByVendorId: number;
  materialCarriedByVendorName: string;
  approverEmailL1: string;
  approverEmailL2: string;
  practiceId: number;
  practiceName: string;
  purpose: string;
  status: string;
  statusId: number;
  previousStatusId:number;
  isActive: boolean;
  cityId: number;
  cityName: string;
  officeId: number;
  officeName: string;
  authorizedBy:string;
  createdBy:string;
  declinedByNotes:string;
  cancelledByNotes:string;
  updatedBy:string;
 // materialList:Material[] = [];
 fTime: Date = new Date;
  dTime:Date=new Date;
  rdTime:Date=new Date;
  receiveddTime:Date=new Date;
  l1time:Date=new Date();
  l2time:Date=new Date();
  l1fromtimevalue:any;
  l2fromtimevalue:any;
  fromtimevalue: any;
  duetimevalue:any;
  revisedduetimevalue:any;
  receivedduetimevalue:any;
  l1approvedDateTime:any;
  l2approvedDateTime:any;
  public materialList:OutwardMaterial[] = [];
  OutwardDetails:Outward;
  id: any;
   service_URL: any;
  private unsubscribe$ =new Subject<void>();
  EditOutwardDetails:any;
  modalRef: BsModalRef;
  selectedRequest: any;
  searchText : string = "";
  showLoading: boolean = true;
  emailId: string ='';
  OutwardStatusName:OutwardStatusName;
  Appr1Data: any;
  Appr2Data: any;
  getAllUsers:any;
  attachedFiles: { name: string, type?: string, data?: string | ArrayBuffer, requestType?: string, fileId?: number }[] = [];
  isMobileView = false;
  private readonly mobileBreakpoint = 768;
  
  constructor(private location: Location,
    private route: ActivatedRoute,
    private outwardService: OutwardService,
    private _dataContextService: DataContextService,
    private modalService: BsModalService,
    private toast: ToastrService,
    private rounter:Router
    ) {
    this.service_URL = ConstantsService;
  }

  ngOnInit(): void {
    this.syncViewportState();
    this.getAppr1Data();
    //this.dateInputData.EndDate = new Date();
    this.id = this.route.snapshot.params['id'];
    this.fillOutwardData(this.id);
    // console.log(this.id);
    this.emailId=localStorage.getItem('email');

    this.dateInputData.StartDate = new Date();
    //this.dateInputData.StartDate.setDate(this.dateInputData.StartDate.getDate() - 7);
    this.dateInputData.maxDate = new Date();
    this.dateInputData.FromMinDate = new Date();
    this.dateInputData.FromMinDate.setDate(this.dateInputData.StartDate.getDate() - 1095);
     
        
 }
  //  addMaterial(){
  //    this.materialList.push(new Material())
  //    console.log(this.materialList)
  //  }
 
  //  removeMaterial(index:number){
  //    if(index > -1){
  //     this.materialList.splice(index,1);
  //    }
  //  }
  //  goBack() : void{
  //    this.location.back();
  //  }
 
  getAppr1Data()
  {
    this._dataContextService.get<any>(this.service_URL.Users.getUser)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(res => {
      this.Appr1Data=res.filter(x=>x.isL1==true);
      this.Appr2Data=res.filter(x=>x.isL2==true);
      this.getAllUsers=res;
      this.fillOutwardData(this.id);
    })
    
  }

fillOutwardData(id: any) {
 let url =this.service_URL.OutwardDetails.GetDataById+'/'+id;
      
 this._dataContextService.get(url)
 .pipe(takeUntil(this.unsubscribe$))
 .subscribe(res=>{
   //  console.log(res);
   this.EditOutwardDetails=res;
   this.OutwardDetails=this.EditOutwardDetails;
   this.requestId=this.OutwardDetails.requestId;
   this.serialNumber=this.OutwardDetails.serialNumber;
   this.requestName=this.OutwardDetails.requestName;
   this.requestTypeName=this.OutwardDetails.requestTypeName;
   this.requestDateTime= moment(this.OutwardDetails.requestDateTime).format("MMM/DD/yy");
   this.returnDateTime=moment(this.OutwardDetails.returnDateTime).format("MMM/DD/Y");
   this.revisedDateTime=moment(this.OutwardDetails.revisedDate).format("MMM/DD/Y");
   this.receivedDateTime=moment(this.OutwardDetails.receivedDate).format("MMM/DD/Y");
   this.fTime =new Date(this.OutwardDetails.requestDateTime);
   this.fromtimevalue = this.GetTimeForDates(this.fTime);
   this.dTime=new Date(this.OutwardDetails.returnDateTime);
   this.duetimevalue=this.GetTimeForDates(this.dTime);
   this.rdTime=new Date(this.OutwardDetails.revisedDate);
   this.receiveddTime=new Date(this.OutwardDetails.receivedDate);
   this.revisedduetimevalue=this.GetTimeForDates(this.rdTime);
   this.receivedduetimevalue=this.GetTimeForDates(this.receiveddTime);
   this.materialSentToVendorName=this.OutwardDetails.materialSentToVendorName;
   this.materialCarriedByVendorName=this.OutwardDetails.materialCarriedByVendorName;
   if(this.OutwardDetails.l1ApprovedDateTime!=null)
   {
    this.l1time =new Date(this.OutwardDetails.l1ApprovedDateTime);
    this.l1fromtimevalue = this.GetTimeForDates(this.l1time);
    this.l1approvedDateTime=moment(this.OutwardDetails.l1ApprovedDateTime).format("MMM/DD/yyy")
   }
   else
   {
    this.l1approvedDateTime="-";
    this.l1fromtimevalue ="";
   }
   if(this.OutwardDetails.l2ApprovedDateTime!=null)
   {
    this.l2time =new Date(this.OutwardDetails.l2ApprovedDateTime);
    this.l2fromtimevalue = this.GetTimeForDates(this.l2time);
    this.l2approvedDateTime=moment(this.OutwardDetails.l2ApprovedDateTime).format("MMM/DD/yyy");
   }
  else
   {
    this.l2approvedDateTime="-";
    this.l2fromtimevalue ="";
   }
   
   if(this.Appr1Data!=undefined && this.Appr1Data!=null ){
    //console.log(this.Appr1Data.filter(x=>x.emailId==this.OutwardDetails.approverEmailL1));
    const l1User = this.Appr1Data.filter(x=>x.emailId==this.OutwardDetails.approverEmailL1);
    if(l1User.length > 0){
      this.approverEmailL1 = l1User[0].firstLastName;
    } else {
       //console.log(this.getAllUsers.filter(x=>x.emailId==this.OutwardDetails.approverEmailL1));
      const l1AllUser = this.getAllUsers.filter(x=>x.emailId==this.OutwardDetails.approverEmailL1);
      this.approverEmailL1 = l1AllUser.length > 0 ? l1AllUser[0].firstLastName : this.OutwardDetails.approverEmailL1;
    }
    
    }//this.OutwardDetails.approverEmailL1;
    if(this.Appr2Data!=undefined && this.Appr2Data!=null ){
    const l2User = this.Appr2Data.filter(x=>x.emailId==this.OutwardDetails.approverEmailL2);
    if(l2User.length > 0){
      this.approverEmailL2 = l2User[0].firstLastName;
    } else {
      const l2AllUser = this.getAllUsers.filter(x=>x.emailId==this.OutwardDetails.approverEmailL2);
      this.approverEmailL2 = l2AllUser.length > 0 ? l2AllUser[0].firstLastName : this.OutwardDetails.approverEmailL2;
    }
  }
    
   this.authorizedBy=this.OutwardDetails.authorizedBy;
   this.practiceName=this.OutwardDetails.practiceName;
   this.purpose=this.OutwardDetails.purpose;
   this.gatepassNumber=this.OutwardDetails.gatepassNo;
   this.cityName=this.OutwardDetails.cityName;
   this.officeName=this.OutwardDetails.officeName;
   this.remark=this.OutwardDetails.remark;
   this.materialList=this.OutwardDetails.materialList;
   this.declinedByNotes=this.OutwardDetails.declinedByNotes;
   this.cancelledByNotes=this.OutwardDetails.cancelledByNotes;
   this.status=this.OutwardDetails.status;
   if (this.OutwardDetails.attachedFiles && this.OutwardDetails.attachedFiles.length > 0) {
    this.attachedFiles = this.OutwardDetails.attachedFiles;
  } else {
    this.attachedFiles = [];
  }
   this.showLoading = false;

 })

       // this._dataContextService.get<any>(url)
       // .pipe(takeUntil(this.unsubscribe$))
       // .subscribe(res => {
       // })
       
}
GetTimeForDates(date: Date): string {
 let time = moment(date).format("hh:mm A");
 return time;
}

@HostListener('window:resize')
onWindowResize(): void {
  this.syncViewportState();
}

onReject(selectedRequest : any){
  this.modalRef = this.modalService.show(SupervisorCommentsComponent,{
    initialState : {
      selectedRequest : selectedRequest
    }
  })
  this.modalRef.setClass(ModalSize.Large);
}

onAccept(selectedRequest : any){
  let newstatus=0;
  let status=selectedRequest.status;
  let oldValue: any = '';
  let newValue: any = '';
  let l1approvedDateTime:any;
  let l2approvedDateTime:any;

  if(status==OutwardStatusName.LAapprover2){
    newstatus=8;
    oldValue = "L2 Approved";
    newValue = "Supervisor Approved";
  }
  else if (status==OutwardStatusName.Supervisor){
    newstatus=9;
    oldValue = "Supervisor Approved";
      newValue = "Print pass";
  }
  else if (status==OutwardStatusName.Created){
      newstatus=5;
      oldValue = "Created";
      newValue = "L1 Approved";
      l1approvedDateTime=new Date().toISOString();
    }
  else if (status==OutwardStatusName.LAapprover1){
      newstatus=7;
      oldValue = "L1 Approved";
      newValue = "L2 Approved";
      l2approvedDateTime=new Date().toISOString();
    }
  else if (status==OutwardStatusName.PrintPass){
      newstatus=10;
      oldValue = "Print pass";
      newValue = "Received";
    }
    let params = {
      statusId : newstatus,
      previousStatusId: OutwardStatus.LAapprover2,
      requestId : this.requestId,
      Updatedby: this.emailId,
      L1ApprovedDateTime:l1approvedDateTime,
      L2ApprovedDateTime:l2approvedDateTime
    }

    let auditData = [];

    let statusChangeAudit: AuditData = new AuditData();
    statusChangeAudit.changedAttribute = "Status";
    statusChangeAudit.oldValue = oldValue;
    statusChangeAudit.newValue = newValue;

    auditData.push(statusChangeAudit);
    
    this._dataContextService.postDatawithValues<any>(this.service_URL.OutwardDetails.UpdateStatus,params)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((res) => {
      if(res == 1){
        if(this.EditOutwardDetails.statusId==OutwardStatus.Created)
          this.toast.success("Request Approved by L1 Approver");
        else if(this.EditOutwardDetails.statusId==OutwardStatus.LAapprover1)
          this.toast.success("Request Approved by L2 Approver");
        else if(this.EditOutwardDetails.statusId==OutwardStatus.LAapprover2)
          this.toast.success("Request Approved by Supervisor");
        
        // Saving Data in Audit Trail - only for specific statuses
        if(status==OutwardStatusName.LAapprover2 || status==OutwardStatusName.Supervisor || status==OutwardStatusName.PrintPass){
          let auditParams = {
            actionPerformed : "Status Change",
            actionPerformedOn : "Outward",
            changedBy : localStorage.getItem('email'),
            dateChanged : new Date(),
            primaryKey : selectedRequest.serialNumber,
            generalInformation : [],
            material : [],
            statusChange: auditData
          };

          console.log('Calling audit trail API:', this.service_URL.AuditTrail.savetransactionaudittrail);
          console.log('Audit trail params:', auditParams);

          this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.savetransactionaudittrail, auditParams)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (auditRes) => {
              console.log('Audit trail saved successfully:', auditRes);
            },
            (auditErr) => {
              console.error('Error saving audit trail:', auditErr);
              this.toast.warning('Approval saved but audit trail failed');
            },
            () => {
              // Delay reload to ensure audit trail completes
              setTimeout(() => {
                window.location.reload();
              }, 500);
            }
          );
        } else {
          // Reload immediately for other statuses
          window.location.reload();
        }
      }
      else{ 
        this.toast.error("Something went wrong");
      }
    },
    (err) => {
      console.error('Error updating status:', err);
      this.toast.error("Something went wrong");
    })
  }

back(){
  this.rounter.navigate(['/OutwardSupervisor']); 
}
viewFile(index: number) {
  if (this.attachedFiles.length > 0 && index < this.attachedFiles.length) {
    const file = this.attachedFiles[index];
    const fileName: string = file.name;
    const fileId = file.fileId;
    const extension = fileName.split('.').pop()?.toLowerCase();

    console.log(`Viewing file: ${fileName}, reqId: ${this.requestId}, fileId: ${fileId}`);
    this._dataContextService.get<any>(`${this.service_URL.OutwardDetails.Download}?reqId=${this.id}&fileId=${fileId}`)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        console.log("download file result: " + res);
        const base64 = res.file.fileBase64;
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        let blob: Blob;
        let mimeType: string;
        
        switch (extension) {
          case 'pdf':
            mimeType = 'application/pdf';
            break;
          case 'doc':
          case 'docx':
            mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            break;
          case 'xls':
          case 'xlsx':
            mimeType = 'application/vnd.ms-excel';
            break;
          case 'jpg':
          case 'jpeg':
            mimeType = 'image/jpeg';
            break;
          case 'png':
            mimeType = 'image/png';
            break;
          default:
            mimeType = 'application/octet-stream';
        }

        blob = new Blob([byteArray], { type: mimeType });
        const blobURL = URL.createObjectURL(blob);
        const fileWindow = window.open("");
        if (fileWindow) {
          if (mimeType.startsWith('image/')) {
            fileWindow.document.write(`<img src='${blobURL}' width='100%' height='100%' />`);
          } else if (mimeType === 'application/pdf') {
            fileWindow.document.write(`<iframe width='100%' height='100%' src='${blobURL}'></iframe>`);
          } else if (mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
            mammoth.convertToHtml({ arrayBuffer: byteArray.buffer })
              .then((result) => {
                fileWindow.document.write(result.value);
              })
              .catch((error) => {
                console.log(error);
                this.toast.error("File could not be rendered");
              });
          } else if (mimeType === 'application/vnd.ms-excel') {
            const workbook = XLSX.read(byteArray, { type: 'array' });
            const html = XLSX.utils.sheet_to_html(workbook.Sheets[workbook.SheetNames[0]]);
            fileWindow.document.write(html);
          } else {
            fileWindow.document.write(`<iframe width='100%' height='100%' src='${blobURL}'></iframe>`);
          }
        }
      },
      (error) => {
        console.log(error);
        this.toast.error("File could not be downloaded");
      });
  } else {
    console.log("Invalid file index or no attached files.");
  }
}

private syncViewportState(): void {
  if (typeof window === 'undefined') {
    this.isMobileView = false;
    return;
  }

  this.isMobileView = window.innerWidth <= this.mobileBreakpoint;
}

downloadFile(index:number){

  if(this.attachedFiles.length > 0){  
    
  var base64: string = "";
  var GatepassNo:string = "";
  var fileName: string = "";
  
  var extension: string = "";
  const file = this.attachedFiles[index];
 
  fileName = file.name;
  var ext = fileName.split(".");
  extension = ext[1];
  var fileId = file.fileId;
  console.log(`Downloading file: ${fileName}, reqId: ${this.requestId}, fileId: ${fileId}`);
  this._dataContextService.get<any>(`${this.service_URL.OutwardDetails.Download}?reqId=${this.id}&fileId=${fileId}`)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
          base64 = res.file.fileBase64;
         // console.log("res.file.gatepassNo:" + res.gatepassNo);
          GatepassNo=res.gatepassNo;
          //console.log("GatepassNo:" + GatepassNo);
      },
      (error) => {
          console.log(error);
          this.toast.error("File could not be downloaded");
      },
      () => {
          var a = document.createElement('a');
          console.log("extension" + extension);
          if(extension === 'pdf'){         
              a.href = "data:application/pdf;base64," + base64;
             // console.log("Material document" +  a.href );
          }else if (extension === 'doc' || extension === 'docx') {
            //const decodedString = atob(base64);
            //const modifiedContent = `Request ID: ${this.requestId}\n\n${decodedString}`;
            //const modifiedBase64 = btoa(modifiedContent);
            a.href = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," + base64;
            //console.log("Material document" + a.href);
          } else if (extension === 'xls' || extension === 'xlsx') {
            a.href = "data:application/vnd.ms-excel;base64," + base64;
            //console.log("Material document" + a.href);
          } 
          else{
              a.href = "data:image/" + extension + ";base64," + base64;
              console.log("Material document" +  a.href );
          }
         // console.log("a.dwonload" + a.download);     
        
          a.download = `GatepassNo_${GatepassNo}_${fileName}`;
         // document.body.appendChild(a);
          a.click();
          //document.body.removeChild(a);
          this.toast.success("File downloaded");
      });
    //});
    }
  }
   
}
